export default __webpack_public_path__ + "static/media/DP2 2A-1EC.0524c0a2.jpg";